import { classNames } from "primereact/utils";
import { RTLContext } from "../../../App";
import { useContext } from "react";
import { Chart } from "primereact/chart";

const OverviewBox = ({
  icon,
  title,
  chartRef,
  chartData,
  chartOptions,
  amount,
  status,
  onClick,
  colClassName = "lg:col-3 xl:col-2",
}) => {
  const isRTL = useContext(RTLContext);

  return (
    <div className={`col-12 md:col-6 ${colClassName}`}>
      <div
        className="card overview-box flex flex-column pt-2"
        onClick={onClick}
        style={{ cursor: "pointer" }}
      >
        <div className="flex align-items-center muted-text">
          <i className={`pi ${icon}`}></i>
          <h6 className={classNames("m-0", { "pl-2": !isRTL, "pr-2": isRTL })}>
            {title}
          </h6>
        </div>
        <div className="flex justify-content-between mt-3 flex-wrap">
          <div className="flex flex-column" style={{ width: "80px" }}>
            <span className="mb-1 fs-xlarge" style={{ color: "black!important" }} >
              {amount}
            </span>
            {status && (
              <span className={`overview-status p-1 ${status}-bgcolor fs-small`}>
                {status}
              </span>
            )}
          </div>
          <div className="flex align-items-end">
            <Chart
              ref={chartRef}
              type="line"
              data={chartData}
              options={chartOptions}
              height="60px"
              width="160px"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default OverviewBox;
